import React, {PureComponent} from 'react'
import {connect} from "react-redux";

import * as actions from "../../store/actions/actions";
import Header from "../../components/Headers/Header";
import {Button, Card, CardBody, CardHeader, Col, Container, FormGroup, Input, Row, UncontrolledTooltip} from "reactstrap";
import {FormControl} from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import FloatingButton from "../../components/button/floatingButton";
import Modal from "react-bootstrap/Modal";
import * as Roles from "../../store/actions/roles";
import "react-toggle/style.css"
import { withLocalize } from "react-localize-redux";
import { Translate } from "react-localize-redux";

import italianCorporateEditTranslations from "../../translations/corporate/edit/it.corporate.edit.json";
import englishCorporateEditTranslations from "../../translations/corporate/edit/en.corporate.edit.json";
import ReactTooltip from "react-tooltip";

class CorporateEdit extends PureComponent {
  state = {
    color: [],
    deleteShow: false,
    disableShow: false,
    contoCorrente: {
      enabled: false,
      contoCorrente: ''
    },

  }

  constructor(props) {
    super(props);

    this.props.addTranslationForLanguage(italianCorporateEditTranslations, "it");
    this.props.addTranslationForLanguage(englishCorporateEditTranslations, "en");
  }

  componentDidMount() {
    this.props.fetchBanks()
    this.props.corporateHasBankAuthorizerExist(this.props.idBank)
  }

  onBackClick = () => {
    this.props.history.goBack();
  }

  submitHandler = (event) => {
    event.preventDefault();
    this.props.updateCorporate(this.props.corporateToEdit)
  }

  handleDeleteShow = (contoCorrente) => {
    this.setState({
      deleteShow: true,
      contoCorrente: contoCorrente
    })
  }

  handleDeleteClose = () => {
    this.setState({
      deleteShow: false
    })
  }

  onDeleteClick = () => {
    let corporate = '';
    let path = this.props.history.location.pathname
    if (path !== 'undefined' && path !== null) {
      corporate = path.split("/")
    }
    let contoCorrente = this.state.contoCorrente
    let data = {
      id: contoCorrente.id,
      contoCorrente: contoCorrente.contoCorrente,
      senderAccount: contoCorrente.senderAccount,
      note: contoCorrente.note,
      enabled: contoCorrente.enabled,
      corporate: corporate[3],
      creationDate: contoCorrente.creationDate,
      createdBy: contoCorrente.createdBy,
      modificationDate: contoCorrente.modificationDate,
      modifiedBy: contoCorrente.modifiedBy,
      deleted: contoCorrente.deleted,
      idBank: this.props.idBank
    }
    this.props.deleteContoCorrente(data)
    this.handleDeleteClose()
  }

  handleEnableDisableteShow = (contoCorrente) => {
    this.setState({
      enableDisableShow: true,
      contoCorrente: contoCorrente
    })
  }

  handleEnableDisableClose = () => {
    this.setState({
      enableDisableShow: false,
      contoCorrente: {
        enabled: false,
        contoCorrente: ''
      }
    })
  }

  onEnableOrDisableClick = () => {
    let corporate = '';
    let path = this.props.history.location.pathname
    if (path !== 'undefined' && path !== null) {
      corporate = path.split("/")
    }
    let data = {
      id: this.state.contoCorrente.id,
      contoCorrente: this.state.contoCorrente.contoCorrente,
      senderAccount: this.state.contoCorrente.senderAccount,
      note: this.state.contoCorrente.note,
      corporate: corporate[3],
      idBank: this.props.idBank
    }
    if(this.state.contoCorrente.enabled === false) {
      this.props.enableContoCorrenteEdit(data)
    } else if(this.state.contoCorrente.enabled === true) {
      this.props.disableContoCorrenteEdit(data)
    }
    this.handleEnableDisableClose()
  }

  render() {

    let deleteModal = <Modal show={this.state.deleteShow} onHide={this.handleDeleteClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          <Translate id="corporate.edit.modal.conto.corrente.delete.title" data={{ contoCorrente: this.state.contoCorrente != null ? this.state.contoCorrente.contoCorrente : "" }}/>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Translate id="corporate.edit.modal.conto.corrente.delete.body" data={{ contoCorrente: this.state.contoCorrente != null ? this.state.contoCorrente.contoCorrente : "" }}/>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={this.handleDeleteClose}>
          <Translate id="corporate.edit.conto.corrente.close"/>
        </Button>
        <Button variant="primary" onClick={this.onDeleteClick}>
          <Translate id="corporate.edit.conto.corrente.delete"/>
        </Button>
      </Modal.Footer>
    </Modal>

    let enableDisableModal = <Modal show={this.state.enableDisableShow} onHide={this.handleEnableDisableClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          {this.state.contoCorrente.enabled === false ?
            <Translate id="corporate.modal.conto.corrente.enable.title" data={{ contoCorrente: this.state.contoCorrente != null ? this.state.contoCorrente.contoCorrente : "" }}/> :
            <Translate id="corporate.modal.conto.corrente.disable.title" data={{ contoCorrente: this.state.contoCorrente != null ? this.state.contoCorrente.contoCorrente : "" }}/>
          }
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {this.state.contoCorrente.enabled === false ?
          <Translate id="corporate.modal.conto.corrente.enable.body" data={{ contoCorrente: this.state.contoCorrente != null ? this.state.contoCorrente.contoCorrente : "" }}/> :
          <Translate id="corporate.modal.conto.corrente.disable.body" data={{ contoCorrente: this.state.contoCorrente != null ? this.state.contoCorrente.contoCorrente : "" }}/>
        }
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={this.handleEnableDisableClose}>
          <Translate id="corporate.edit.conto.corrente.close"/>
        </Button>
        <Button variant="primary" onClick={this.onEnableOrDisableClick}>
          {this.state.contoCorrente.enabled === false ?
            <Translate id="corporate.edit.conto.corrente.enable.button"/> :
            <Translate id="corporate.edit.conto.corrente.disable.button"/>
          }
        </Button>
      </Modal.Footer>
    </Modal>

    let role = this.props.role

    let errors="";
    errors=this.props.validationError;
    let corporateSenderIdError = ""
    let corporateSenderNameError=""
    let logoError=""
    let bankError=""
    let firstReminderNegative=""
    let secondReminderNegative=""
    let validityNegative=""
    if(errors !== null && errors !== "" && errors !== undefined){
      if(errors.data.length>0){
        errors.data.map((item) =>{
          if(item.field === 'corporateSenderId')
            corporateSenderIdError=item.defaultMessage;
          if(item.field === 'corporateSenderName')
            corporateSenderNameError=item.defaultMessage;
          if(item.field === 'bank')
            bankError=item.defaultMessage;
          if(item.field === 'logo')
            logoError=item.defaultMessage;
          if(item.field === 'daysToFirstReminder')
            firstReminderNegative=item.defaultMessage;
          if(item.field === 'daysToSecondReminder')
            secondReminderNegative=item.defaultMessage;
          if(item.field === 'timeToExpiry')
            validityNegative=item.defaultMessage;
          return ""
        });
      }
    }

  let enableDisableButton = "";
  if(Roles.checkRole(role,Roles.MODULE_CORPORATE,Roles.OPERATION_CONTO_EDIT, true)) {
    enableDisableButton = {
      text: <Translate id="corporate.edit.conto.corrente.enable.disable"/>,
      align: 'center',
      formatter: (cellContent, row) => (
        <Button size="sm" onClick={() => this.handleEnableDisableteShow(row)}>
          {row.enabled === true ? <i className="fas fa-power-off text-danger"/> :
            <i className="fas fa-power-off text-success"/>}
        </Button>
      )
    }

  }

  let editButton= ""
  if(Roles.checkRole(role,Roles.MODULE_CORPORATE,Roles.OPERATION_CONTO_EDIT, true)) {
    editButton = {
      text: <Translate id="corporate.edit.conto.corrente.edit"/>,
      align: 'center',
      formatter: (cellContent, row) => (
        <Button size="sm" onClick={() => this.onEditContoCorrenteClick(row)}>
          <i className="ni ni-ui-04 text-yellow"/>
        </Button>
      )
    }
  }

  const columns = [
  { dataField: 'contoCorrente',
    text: <Translate id="corporate.edit.conto.corrente.conto.corrente"/>, align: 'center',
    sort: true,
    sortCaret: (order, column) => {
      if (!order)
        return (<span>&nbsp;&nbsp;<i className="ni ni-bold-up" /><i className="ni ni-bold-down" /></span>);
      else if (order === 'asc') return (<span>&nbsp;&nbsp;<i className="ni ni-bold-up" /><font color="red"><i className="ni ni-bold-down" /></font></span>);
      else if (order === 'desc') return (<span>&nbsp;&nbsp;<font color="red"><i className="ni ni-bold-up" /></font><i className="ni ni-bold-down" /></span>);
      return null;
    }
  },
  { dataField: 'senderAccount',
    text: <Translate id="corporate.edit.conto.corrente.sender.account"/>, align: 'center',
    sort: true,
    sortCaret: (order, column) => {
      if (!order)
        return (<span>&nbsp;&nbsp;<i className="ni ni-bold-up" /><i className="ni ni-bold-down" /></span>);
      else if (order === 'asc') return (<span>&nbsp;&nbsp;<i className="ni ni-bold-up" /><font color="red"><i className="ni ni-bold-down" /></font></span>);
      else if (order === 'desc') return (<span>&nbsp;&nbsp;<font color="red"><i className="ni ni-bold-up" /></font><i className="ni ni-bold-down" /></span>);
      return null;
    }
  },
  { dataField: 'note', text: <Translate id="corporate.edit.conto.corrente.note"/>, align: 'center',
    sort: true,
    sortCaret: (order, column) => {
      if (!order)
        return (<span>&nbsp;&nbsp;<i className="ni ni-bold-up" /><i className="ni ni-bold-down" /></span>);
      else if (order === 'asc') return (<span>&nbsp;&nbsp;<i className="ni ni-bold-up" /><font color="red"><i className="ni ni-bold-down" /></font></span>);
      else if (order === 'desc') return (<span>&nbsp;&nbsp;<font color="red"><i className="ni ni-bold-up" /></font><i className="ni ni-bold-down" /></span>);
      return null;
    }
  },
  { dataField: 'enabled', text: <Translate id="corporate.edit.conto.corrente.enabled"/>, align: 'center',
    formatter: (cellContent, row) => (
    <div className="disabled">
    <input type="checkbox" checked={ row.enabled } disabled />
    </div>
    )
  },
  editButton,
  enableDisableButton,
  /*deleteButton*/
  ]
  const rowEvents = {
    scope:"row"
  };
  let table = Roles.checkRole(role,Roles.MODULE_CORPORATE,Roles.OPERATION_CONTO_VIEW, true) === false ? null :
    <BootstrapTable bootstrap4
                    headerClasses="thead-light"
                    classes="align-items-center table-flush"
                    keyField='contoCorrente'
                    data={ this.props.contiCorrenti }
                    columns={ columns }
                    pagination={ paginationFactory() }
                    rowEvents={ rowEvents }
    />
  let createButton = <FloatingButton label="Create conto corrente" onClick={this.onAddContoCorrenteClick} color="primary" />

    let autoaccept = ''
    let autoacceptTooltipComponent = ''
    if (role === 'BANK_CORPORATE_ADMIN' || role === 'BANK_ADMIN' || role === 'CORPORATE_ADMIN' || role === 'PAYDO_ADMIN'|| role === 'PAYDO_MANAGER') {
      autoacceptTooltipComponent = <UncontrolledTooltip delay={0} placement="top" target="autoacceptTooltip">
        Funzionalità temporaneamente disabilitata. Nel caso di necessità, chiedere supporto al team PayDo al seguente indirizzo e-mail
        <br />
        <a href="mailto:supporto_clienti@plick.eu">supporto_clienti@plick.eu</a>
      </UncontrolledTooltip>
      autoaccept = <span id="autoacceptTooltip">
        <input id="autoaccept"
             disabled
             value={this.props.corporateAutoAccept}
             type="checkbox"
             checked={this.props.corporateAutoAccept}
             onChange={(event) => this.onCorporateAutoAcceptChange(event.target.checked)} />
      </span>
    } else {
      autoaccept = <input id="autoaccept"
             value={this.props.corporateAutoAccept}
             type="checkbox"
             checked={this.props.corporateAutoAccept}
             onChange={(event) => this.onCorporateAutoAcceptChange(event.target.checked)}  />
    }

    let whatsapp = ''
    let whatsappTooltipComponent = ''
    if (role === 'BANK_CORPORATE_ADMIN' || role === 'BANK_ADMIN' || role === 'CORPORATE_ADMIN' || role === 'PAYDO_ADMIN'|| role === 'PAYDO_MANAGER') {
      whatsappTooltipComponent = <UncontrolledTooltip delay={0} placement="top" target="whatsappTooltip">
        Funzionalità temporaneamente disabilitata. Nel caso di necessità, chiedere supporto al team PayDo al seguente indirizzo e-mail
        <br />
        <a href="mailto:supporto_clienti@plick.eu">supporto_clienti@plick.eu</a>
      </UncontrolledTooltip>
      whatsapp =
          <span id="whatsappTooltip">
            <input id="whatsapp"
                 disabled
                 value={this.props.corporateWhatsapp}
                 type="checkbox"
                 checked={this.props.corporateWhatsapp}
                 onChange={(event) => this.onCorporateWhatsappChange(event.target.checked)}/>
          </span>
    } else {
      whatsapp =<input id="whatsapp"
             value={this.props.corporateWhatsapp}
             type="checkbox"
             checked={this.props.corporateWhatsapp}
             onChange={(event) => this.onCorporateWhatsappChange(event.target.checked)}/>
    }

    let daysToFirstReminder = ''
    let firstReminderTooltipComponent = ''
    if (role === 'BANK_CORPORATE_ADMIN' || role === 'BANK_ADMIN' || role === 'CORPORATE_ADMIN' || role === 'PAYDO_ADMIN'|| role === 'PAYDO_MANAGER') {
      firstReminderTooltipComponent = <UncontrolledTooltip delay={0} placement="top" target="firstReminderTooltip">
        Funzionalità temporaneamente disabilitata. Nel caso di necessità, chiedere supporto al team PayDo al seguente indirizzo e-mail
        <br />
        <a href="mailto:supporto_clienti@plick.eu">supporto_clienti@plick.eu</a>
      </UncontrolledTooltip>
      daysToFirstReminder = <span id="firstReminderTooltip"><Translate>
        {({ translate }) => <Input id="daysToFirstReminder"
             disabled
             className={'form-control-alternative' }
             defaultValue="lucky.jesse"
             value={this.props.corporateDaysToFirstReminder} onChange={this.onCorporateDaysToFirstReminderChange}
             placeholder={translate("corporate.edit.days.to.firstreminder")}
             type="number" />
        }
      </Translate></span>
    } else {
      daysToFirstReminder = <Translate>
        {({ translate }) => <Input id="daysToFirstReminder"
             className={'form-control-alternative' }
             defaultValue="lucky.jesse"
             value={this.props.corporateDaysToFirstReminder} onChange={this.onCorporateDaysToFirstReminderChange}
             placeholder={translate("corporate.edit.days.to.firstreminder")}
             type="number" />
        }
      </Translate>
    }

    let daysToSecondReminder = ''
    let secondReminderTooltipComponent = ''
    if (role === 'BANK_CORPORATE_ADMIN' || role === 'BANK_ADMIN' || role === 'CORPORATE_ADMIN' || role === 'PAYDO_ADMIN'|| role === 'PAYDO_MANAGER') {
      secondReminderTooltipComponent = <UncontrolledTooltip delay={0} placement="top" target="secondReminderTooltip">
        Funzionalità temporaneamente disabilitata. Nel caso di necessità, chiedere supporto al team PayDo al seguente indirizzo e-mail
        <br />
        <a href="mailto:supporto_clienti@plick.eu">supporto_clienti@plick.eu</a>
      </UncontrolledTooltip>
      daysToSecondReminder = <span id="secondReminderTooltip"><Translate>
        {({ translate }) =>
            <Input id="daysToSecondReminder"
                   disabled
                   className={'form-control-alternative' }
                   defaultValue="lucky.jesse"
                   value={this.props.corporateDaysToSecondReminder} onChange={this.onCorporateDaysToSecondReminderChange}
                   placeholder={translate("corporate.edit.days.to.secondreminder")}
                   type="number" />
        }
      </Translate></span>
    } else {
      daysToSecondReminder = <span id=""><Translate>
        {({ translate }) =>
            <Input id="daysToSecondReminder"
                   className={'form-control-alternative' }
                   defaultValue="lucky.jesse"
                   value={this.props.corporateDaysToSecondReminder} onChange={this.onCorporateDaysToSecondReminderChange}
                   placeholder={translate("corporate.edit.days.to.secondreminder")}
                   type="number" />
        }
      </Translate></span>
    }

    let corporateTimeToExpiry = ''
    let expiryTooltipComponent = ''
    if (role === 'BANK_CORPORATE_ADMIN' || role === 'BANK_ADMIN' || role === 'CORPORATE_ADMIN' || role === 'PAYDO_ADMIN'|| role === 'PAYDO_MANAGER') {
      expiryTooltipComponent = <UncontrolledTooltip delay={0} placement="top" target="expiryTooltip">
        Funzionalità temporaneamente disabilitata. Nel caso di necessità, chiedere supporto al team PayDo al seguente indirizzo e-mail
        <br />
        <a href="mailto:supporto_clienti@plick.eu">supporto_clienti@plick.eu</a>
      </UncontrolledTooltip>
      corporateTimeToExpiry = <span id="expiryTooltip"><Translate>
        {({ translate }) =>
            <Input id="corporateTimeToExpiry"
                   disabled
                   className={'form-control-alternative' }
                   defaultValue="lucky.jesse"
                   value={this.props.corporateTimeToExpiry} onChange={this.onCorporateTimeToExpiryChange}
                   placeholder={translate("corporate.edit.days.to.expiry")}
                   type="number" />}
      </Translate></span>
    } else {
      corporateTimeToExpiry = <Translate>
        {({ translate }) =>
            <Input id="corporateTimeToExpiry"
                   className={'form-control-alternative' }
                   defaultValue="lucky.jesse"
                   value={this.props.corporateTimeToExpiry} onChange={this.onCorporateTimeToExpiryChange}
                   placeholder={translate("corporate.edit.days.to.expiry")}
                   type="number" />}
      </Translate>
    }


    let hasAuthorizerCheck = ''
    if(role === Roles.BANK_ADMIN){
      hasAuthorizerCheck = <input disabled
                                  id="email"
                                  value={this.props.hasBankAuthorizer}
                                  type="checkbox"
                                checked={true}   />
    } else {
      hasAuthorizerCheck = <input disabled={this.props.noAuthorizer}
                                  id="email" value={this.props.hasBankAuthorizer}
                                  type="checkbox"
                                checked={this.props.hasBankAuthorizer}
                                  onChange={(event) => this.onCorporateHasBankAuthorizerChange(event.target.checked)}  />
    }


    return (
        <>
          <Header />
          <Container className="mt--5" fluid>
            <Row>
              <div className="col" style={{paddingBottom:"2%"}}>
                <Card className="shadow">
                  <CardHeader className="border-0">
                    <Row>
                      <div className="col">
                        <h3 className="mb-0">
                          <Translate id="corporate.edit.title" data={{ corporateSenderName: this.props.corporateSenderName }}/>
                        </h3>
                      </div>
                    </Row>
                  </CardHeader>
                  <CardBody>
                    <form onSubmit={this.submitHandler}>
                      <div className="pl-lg-4">
                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label" htmlFor="corporateSenderId">
                                <Translate id="corporate.edit.sender.id"/>
                              </label>
                              <Translate>
                                {({ translate }) =>
                                  <Input
                                      disabled
                                  className={corporateSenderIdError.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative' }
                                  defaultValue="lucky.jesse"
                                  value={this.props.corporateSenderId}
                                  onChange={this.onCorporateSenderIdChange}
                                  id="corporateSenderId"
                                  placeholder={translate("corporate.edit.sender.id")}
                                  type="text" />}
                              </Translate>
                              { corporateSenderIdError.length > 0 ? <label style={{color:"red"}}><Translate id={corporateSenderIdError}/></label> : "" }
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label" htmlFor="corporateSenderId">
                                <Translate id="corporate.edit.sender.name"/>
                              </label>
                              <Translate>
                                {({ translate }) =>
                                  <Input
                                  className={corporateSenderNameError.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative' }
                                  defaultValue="lucky.jesse"
                                  value={this.props.corporateSenderName}
                                  onChange={this.onCorporateSenderNameChange}
                                  id="corporateSenderName"
                                  placeholder={translate("corporate.edit.sender.name")}
                                  type="text" />}
                              </Translate>
                              { corporateSenderNameError.length > 0 ? <label style={{color:"red"}}><Translate id={corporateSenderNameError}/></label> : "" }
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label" htmlFor="corporateSenderId">
                                <Translate id="corporate.edit.bank"/>
                              </label>
                              <FormControl className={bankError.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative' }
                                           disabled
                                           as="select" onChange={(newValue) => {
                                this.onIdBankChange(newValue.target.value);
                              }}>
                                {this.props.banks.map((item)=>{
                                  if(item.bankId=== this.props.idBank){
                                    return <option value={item.bankId} selected="selected" >{item.bankName}</option>
                                  }else{
                                    return <option value={item.bankId} >{item.bankName}</option>
                                  }

                                })}
                              </FormControl>
                              { bankError.length > 0 ? <label style={{color:"red"}}><Translate id={bankError}/></label> : "" }
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label" htmlFor="corporateSenderId">
                                <Translate id="corporate.edit.logo"/>
                              </label>
                              <Translate>
                                {({ translate }) =>
                                  <Input
                                    className={logoError.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative' }
                                    onChange={this.onCorporateLogoChange}
                                    id="files"
                                    placeholder="Corporate Logo"
                                    type="file"/>}
                              </Translate>
                              <span>
                                <small>
                                  <Translate id="corporate.edit.logo.size" />
                                </small>
                              </span>
                              { logoError.length > 0 ? <label style={{color:"red"}}><Translate id={logoError}/></label> : "" }
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <Row>
                              <Col>
                                <label className="form-control-label" htmlFor="files">
                                  <Translate id="corporate.edit.primary.color"/>
                                </label>
                                <div>
                                  <label>
                                    <div className="result" style={{backgroundColor: this.state.color}}></div>
                                    <input type="color" id="color-picker" ref="color-value"
                                           onChange={this.onCorporateImagePrimaryColorChange.bind(this)}
                                           value={this.props.primaryColor}
                                    />
                                    <span className="select"></span>
                                  </label>
                                </div>
                              </Col>
                              <Col>
                                <FormGroup>
                                  <label className="form-control-label" htmlFor="files">
                                    <Translate id="corporate.edit.hasAuthorizer"/>
                                  </label>
                                  <br></br>
                                  {hasAuthorizerCheck}
                                </FormGroup>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <FormGroup>
                              <label className="form-control-label" htmlFor="files">
                                <Translate id="corporate.edit.autoaccept"/>
                              </label>
                              <i className="fa fa-info-circle" aria-hidden="true" data-tip data-for="autoacceptTip">
                              </i>
                              <ReactTooltip id="autoacceptTip" place="right" effect="solid" multiline={true} className="tooltip">
                                <Translate id="corporate.edit.autoaccept.tip"/>
                              </ReactTooltip>
                              <br></br>
                              {autoaccept}
                            </FormGroup>
                          </Col>
                          <Col>
                            <FormGroup>
                              <label className="form-control-label" htmlFor="files">
                                <Translate id="corporate.edit.whatsapp"/>
                              </label>
                              <br></br>
                              {whatsapp}
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <FormGroup>
                              <label className="form-control-label" htmlFor="daysToFirstReminder">
                                <Translate id="corporate.edit.days.to.firstreminder"/> *
                              </label>
                              {daysToFirstReminder}
                              { firstReminderNegative.length > 0 ? <label style={{color:"red"}}><Translate id={firstReminderNegative}/></label> : "" }
                            </FormGroup>
                          </Col>
                          <Col>
                            <FormGroup>
                              <label className="form-control-label" htmlFor="daysToSecondReminder">
                                <Translate id="corporate.edit.days.to.secondreminder"/> *
                              </label>
                              {daysToSecondReminder}
                              { secondReminderNegative.length > 0 ? <label style={{color:"red"}}><Translate id={secondReminderNegative}/></label> : "" }
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <FormGroup>
                              <label className="form-control-label" htmlFor="corporateTimeToExpiry">
                                <Translate id="corporate.edit.days.to.expiry"/>
                              </label>
                              {corporateTimeToExpiry}
                              { validityNegative.length > 0 ? <label style={{color:"red"}}><Translate id={validityNegative}/></label> : "" }
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <div className="col">
                            <Card className="shadow">
                              <CardHeader className="border-0">
                                {Roles.checkRole(role,Roles.MODULE_CORPORATE,Roles.OPERATION_CONTO_EDIT, true) === true ?
                                  <Row>
                                  <div className="col">
                                    <h3 className="mb-0"><Translate id="conto.corrente.edit.header"/></h3>
                                  </div>
                                  <div className="col">
                                    <div style={{float:'right'}}>
                                      {createButton}
                                    </div>
                                  </div>
                                </Row> : ""
                                }
                              </CardHeader>
                              {table}
                              {deleteModal}
                              {enableDisableModal}
                            </Card>
                          </div>
                        </Row>
                        <Row>
                            <Col align="left">
                              <Button onClick={this.onBackClick} variant="contained">
                                <i className="fas fa-arrow-left text-primary" />
                              </Button>
                            </Col>
                            <Col align="right">
                              <Button  type="submit" className="btn-success" variant="contained" >
                                <Translate id="corporate.edit.update.button" data={{ corporateSenderName: this.props.corporateSenderName}}/>
                              </Button>
                            </Col>
                        </Row>
                      </div>
                    </form>
                  </CardBody>
                  {whatsappTooltipComponent}
                  {autoacceptTooltipComponent}
                  {firstReminderTooltipComponent}
                  {secondReminderTooltipComponent}
                  {expiryTooltipComponent}
                </Card>
              </div>
            </Row>
          </Container>
        </>
    );
  }

  onCorporateHasBankAuthorizerChange(hasBank){
    if(hasBank ===true){

      this.props.corporateHasBankAuthorizerChange(true)
    }else if(hasBank ===false){

      this.props.corporateHasBankAuthorizerChange(false)
    }
    // this.props.getGeneralReport(this.props.generalReport)
  }

  onCorporateImagePrimaryColorChange=(value)=>{
    var tValue = value.target.value;
    this.props.corporatePrimaryColorChangeRequest(tValue)
  }
  onCorporateImageSecondaryColorChange=(value)=>{
    var tValue = value.target.value;
    this.props.corporateSecondaryColorChangeRequest(tValue)
  }

  onAddContoCorrenteClick = () => {
    let corporateId = '';
    let path = this.props.history.location.pathname
    if (path !== 'undefined' && path !== null) {
      corporateId = path.split("/")
    }

    let corporateData = {idBank: this.props.idBank,corporateId: corporateId[3]}

    this.props.createContoCorrente(corporateData)
  }

  onEditContoCorrenteClick = (contoCorrente) => {
    let corporateId = '';
    let path = this.props.history.location.pathname
    if (path !== 'undefined' && path !== null) {
      corporateId = path.split("/")
    }
    let corporateData = {bankId: this.props.idBank,contoCorrente: contoCorrente.id, corporate: corporateId[3]}
    this.props.editContoCorrente(corporateData)
  }

  onCorporateSenderIdChange = (event) => {
    let corporateSenderId = event.target.value
    this.props.corporateSenderIdChange(corporateSenderId)
  }

  onCorporateSenderNameChange = (event) => {
    let corporateSenderName = event.target.value
    this.props.corporateSenderNameChange(corporateSenderName)
  }

  onCorporateLogoChange = async (event) => {
    let image = event.target.files[0]
    event.preventDefault();
    let toBase64 = file => new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
    this.props.corporateLogoChange(await toBase64(image))
  }

  onCorporateTimeToExpiryChange = (event) => {
    let timeToExpiry = event.target.value
    this.props.corporateTimeToExpiryChange(timeToExpiry)
  }

  onCorporateAutoAcceptChange(autoAccept){
    if(autoAccept ===true){
      this.props.corporateAutoAcceptChange(true)
    }else if(autoAccept ===false){
      this.props.corporateAutoAcceptChange(false)
    }
    // this.props.getGeneralReport(this.props.generalReport)
  }
  onCorporateWhatsappChange(whatsapp){
    if(whatsapp ===true){
      this.props.corporateWhatsappChange(true)
    }else if(whatsapp ===false){
      this.props.corporateWhatsappChange(false)
    }
    // this.props.getGeneralReport(this.props.generalReport)
  }
  onCorporateDaysToFirstReminderChange = (event) => {
    let  daysToFirstReminder= event.target.value
    this.props.corporateDaysToFirstReminderChange(daysToFirstReminder)
  }

  onCorporateDaysToSecondReminderChange = (event) => {
    let  daysToSecondReminder = event.target.value
    this.props.corporateDaysToSecondReminderChange(daysToSecondReminder)
  }
}

const mapStateToProps = state => {
  return {
    corporateToEdit: state.corporateEdit.corporateToEdit,
    idBank: state.corporateEdit.corporateToEdit.bank,
    corporateSenderId: state.corporateEdit.corporateToEdit.corporateSenderId,
    corporateSenderName: state.corporateEdit.corporateToEdit.corporateSenderName,
    corporateAutoAccept: state.corporateEdit.corporateToEdit.autoAccept,
    corporateTimeToExpiry: state.corporateEdit.corporateToEdit.timeToExpiry,
    corporateDaysToFirstReminder: state.corporateEdit.corporateToEdit.daysToFirstReminder,
    corporateDaysToSecondReminder: state.corporateEdit.corporateToEdit.daysToSecondReminder,
    corporateWhatsapp: state.corporateEdit.corporateToEdit.whatsapp,
    enabled: state.corporateEdit.corporateToEdit.enabled === true ? "true" : "false",
    contiCorrenti: state.corporateEdit.corporateToEdit.contiCorrenti,
    corporateLogo: state.corporateEdit.corporateToEdit.logo,
    banks: state.bank.banks,
    validationError:state.corporateEdit.error,
    role: state.authentication.authenticatedUser.role,
    primaryColor:state.corporateEdit.corporateToEdit.primaryColor,
    secondaryColor:state.corporateEdit.corporateToEdit.secondaryColor,
    noAuthorizer:state.corporateEdit.noAuthorizer,
    hasBankAuthorizer:state.corporateEdit.corporateToEdit.hasBankAuthorizer,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    updateCorporate: (corporate) => dispatch({type: actions.UPDATE_CORPORATE_EDIT_REQUEST, value: corporate}),
    idBankChange: (idBank) => dispatch({type: actions.EDIT_CORPORATE_ID_BANK_FIELD_CHANGE_REQUEST, value: idBank}),
    corporateSenderNameChange: (corporateSenderName) => dispatch({type: actions.EDIT_CORPORATE_CORPORATE_SENDER_NAME_FIELD_CHANGE_REQUEST, value: corporateSenderName}),
    corporateSenderIdChange: (corporateSenderId) => dispatch({type: actions.EDIT_CORPORATE_CORPORATE_SENDER_ID_FIELD_CHANGE_REQUEST, value: corporateSenderId}),
    enabledChange: (enabled) => dispatch({type: actions.EDIT_CORPORATE_ENABLED_FILED_CHANGE_REQUEST, value: enabled}),
    fetchBanks: () => dispatch({type: actions.FETCH_BANKS_REQUEST}),
    enableContoCorrenteEdit: (contoCorrente) => dispatch({type: actions.ENABLE_CONTO_CORRENTE_REQUEST, value: contoCorrente}),
    disableContoCorrenteEdit: (contoCorrente) => dispatch({type: actions.DISABLE_CONTO_CORRENTE_REQUEST, value: contoCorrente}),
    createContoCorrente: (corporateData) => dispatch({type: actions.CREATE_CONTO_CORRENTE_PAGE_REQUEST, value: {bankId:corporateData.bankId,corporateId:corporateData.corporateId}}),
    editContoCorrente: (corporateData) => dispatch({type: actions.FETCH_CONTO_CORRENTE_EDIT_REQUEST, value: corporateData}),
    corporateLogoChange: (corporateLogo) => dispatch({ type: actions.EDIT_CORPORATE_CORPORATE_LOGO_FILED_CHANGE_REQUEST, value: corporateLogo }),
    deleteContoCorrente: (contoCorrente) => dispatch({ type: actions.DELETE_CONTO_CORRENTE_REQUEST, value: contoCorrente }),
    corporatePrimaryColorChangeRequest:(color)=>dispatch({type:actions.CORPORATE_PRIMARY_COLOR_CHANGE_REQUEST,value:color}),
    corporateSecondaryColorChangeRequest:(color)=>dispatch({type:actions.CORPORATE_SECONDARY_COLOR_CHANGE_REQUEST,value:color}),
    corporateAutoAcceptChange: (autoAccept) => dispatch({ type: actions.EDIT_CORPORATE_CORPORATE_AUTOACCEPT_FIELD_CHANGE_REQUEST, value: autoAccept }),
    corporateTimeToExpiryChange: (timeToExpiry) => dispatch({ type: actions.EDIT_CORPORATE_CORPORATE_TIME_TO_EXPIRE_FIELD_CHANGE_REQUEST, value: timeToExpiry }),
    corporateHasBankAuthorizerChange: (hasBank) => dispatch({ type: actions.EDIT_CORPORATE_CORPORATE_HAS_BANK_AUTHORIZER_CHANGE_REQUEST, value: hasBank }),
    corporateHasBankAuthorizerExist: (bankId) => dispatch({ type: actions.EDIT_CORPORATE_CORPORATE_HAS_BANK_AUTHORIZER_EXISTS_REQUEST, value: bankId }),
    corporateDaysToFirstReminderChange: (firstReminder) => dispatch({ type: actions.EDIT_CORPORATE_CORPORATE_DAYS_TO_FIRST_REMINDER_FIELD_CHANGE_REQUEST, value: firstReminder }),
    corporateDaysToSecondReminderChange: (secondReminder) => dispatch({ type: actions.EDIT_CORPORATE_CORPORATE_DAYS_TO_SECOND_REMINDER_FIELD_CHANGE_REQUEST, value: secondReminder }),
    corporateWhatsappChange: (whatsapp) => dispatch({ type: actions.EDIT_CORPORATE_CORPORATE_WHATSAPP_FIELD_CHANGE_REQUEST, value: whatsapp }),
  }
}

export default withLocalize(connect(mapStateToProps, mapDispatchToProps)(CorporateEdit));